module.exports = __webpack_public_path__ + "static/media/JM.3ec91dad.png";